export type Role = 'Manager' | 'Goalkeeper' | 'Defender' | 'Midfielder' | 'Forward';

export type StatisticsType =
  | 'Assists'
  | 'Cleansheets'
  | 'Duels'
  | 'DuelsLost'
  | 'DuelsWon'
  | 'GamesPlayed'
  | 'Goals'
  | 'KeyPasses'
  | 'Starts'
  | 'TimePlayed'
  | 'TotalPasses'
  | 'TotalShots'
  | 'YellowCards'
  | 'SavesMade'
  | 'Recoveries'
  | 'TotalLossesOfPossession'
  | 'TotalFoulsWon'
  | 'TotalFoulsConceded'
  | 'PenaltyGoals'
  | 'GoalsConceded'
  | 'PenaltiesSaved'
  | 'TotalRedCards';

export const playerMovementOrderStats = [
  'GamesPlayed',
  'Starts',
  'Goals',
  'TimePlayed',
  'PenaltyGoals',
  'Assists',
  'TotalShots',
  'KeyPasses',
  'Recoveries',
  'TotalLossesOfPossession',
  'TotalFoulsConceded',
  'TotalFoulsWon',
  'YellowCards',
  'TotalRedCards',
];

export const playerMovementOrderChart = ['TotalPasses', 'TotalShots', 'Duels'];

export const playerGoalkeeperOrderStats = [
  'GamesPlayed',
  'TimePlayed',
  'SavesMade',
  'Cleansheets',
  'GoalsConceded',
  'PenaltiesSaved',
  'YellowCards',
  'TotalRedCards',
];

export const playerGoalkeeperOrderChart = ['TotalPasses'];